import { styled, component } from '../../../../utils/style';
import { Format, StyleColor } from '../../../../utils/styles-constants';
import { DriveItemListSearchFieldDisplayType } from './constants';

interface DriveItemListSearchFieldContainerProps {
	isShown: boolean;
}

const DriveItemListSearchFieldContainer = styled<DriveItemListSearchFieldContainerProps>()(component.form, 'DriveItemListSearchFieldContainer')``;

export const DriveItemListSearchFieldContainerVariants: ({}) = {
	[DriveItemListSearchFieldDisplayType.Desktop]: DriveItemListSearchFieldContainer.extend`
		position: relative;
		height: 34px;
		width: 240px;
		margin-right: 5px;

		@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
			display: none
		}
	`,
	[DriveItemListSearchFieldDisplayType.Mobile]: DriveItemListSearchFieldContainer.extend`
		display: flex;
		align-items: center;
		transition: all 0.2s;
		overflow: hidden;
		background: ${StyleColor.Grey50};
		height: ${ props => props.isShown ? '55px' : 0};

		@media ${ Format.LargeDesktop } {
			display: none;
		}
	`,
};

interface DriveItemListSearchFieldInputProps {
	isEmpty: boolean;
}

export const DriveItemListSearchFieldInput = styled<DriveItemListSearchFieldInputProps>()(component.input, 'DriveItemListSearchFieldInput')`
	background: ${StyleColor.Grey50};
	flex-grow: 1;
	outline: 0;
	text-overflow: ellipsis;
	color: ${StyleColor.Black};
	font-size: 12px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		border: 0;
	}

	@media ${Format.LargeDesktop} {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: 1px solid ${StyleColor.Grey300};
		border-radius: 4px;
		box-sizing: border-box;
		padding-left: 35px;
		padding-right: ${ props => props.isEmpty ? 0 : '30px'};
		transition: all 0.2s;

		:focus{
			border-color: black;
		}
	}

	::placeholder{
		color: ${StyleColor.Grey400};
		font-style: italic;
	};

	/* removes the clear field "X" button automatically added by IE & Edge*/
	::-ms-clear {
		display: none;
	}
`;

interface ButtonIconProps {
	isLeft: boolean;
}

const getButtonIconLargeDesktopCss = (isLeft: boolean) => {

	const position = isLeft ? 'left' : 'right';
	return `
		@media ${Format.LargeDesktop} {
			position: absolute;
			top: 0;
			${ position}: 0;
			margin: 0 1px;
		}

		@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
			height: 45px;
			width: 45px;
		}
	`;
};

export const ButtonIcon = styled<ButtonIconProps>()(component.button, 'ButtonIcon')`
	height: 34px;
	width: 34px;
	background: none;
	border: 0;
	outline: 0;
	cursor: pointer;
	z-index: 1;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		height: 45px;
		width: 45px;
	}

	@media ${Format.LargeDesktop} {
		${ props => getButtonIconLargeDesktopCss(props.isLeft) }
	}

	svg {
		fill: ${StyleColor.Grey500};
		height: 100%;
		width: 100%;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Field/styles.ts